var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12.9999H9V10.9999H4V12.9999ZM4 16.9999H8V14.9999H4V16.9999ZM4 8.99989H9V6.9999H4V8.99989ZM15 12.9999H19V10.9999H15V12.9999ZM15 16.9999H20V14.9999H15V16.9999ZM15 8.99989H20V6.9999H15V8.99989ZM22 20H15L13 21V5L15 4H22V20ZM11 21L9 20H2V4H9L11 5V21ZM15 2L13 3H11L9 2L0 2.02V22L0.0199963 21.98L9 22L11 23H13L15 22L23.98 21.98L24 22V2.02L15 2Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticleIcon);
export default __webpack_public_path__ + "static/media/ArticleIcon.ec46a4176c0ab66a07e21eb6ee92277f.svg";
export { ForwardRef as ReactComponent };